import { notification } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps, useHistory, useLocation } from 'react-router-dom';
import { UserLoginSuccessResponse } from '../../../../Models/Response/Authentication/Otp';
import {
  logInWithPin,
  sendOtp,
  verifyOtp,
} from '../../../../Services/AuthenticationServices/AuthenticationServices';
import { setCredentialsLocalStorage } from '../../../../Services/LocalStorageServices';
import { QueryParams, Routes } from '../../../../Utils/Constants/routes';
import getIsRedirection from '../../../../Utils/redirectionUtility';
import OTPInputComponent from '../../../Common/Components/OTPModal';
import LoginSignupForm from '../Form';
import LoginSignupSidePanel from '../Greetings';
import './index.css';

const LoginComponent: React.FC = () => {
  const [isOTPModalVisible, setOTPModalVisibility] = useState(false);
  const [isLoginWithPin, setIsLoginWithPin] = useState(true);
  const [otpUniqueID, setOTPUniqueId] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');

  const history = useHistory();
  const location = useLocation();

  const redirect: any = location.state;
  const { t } = useTranslation();

  const closeModal = () => {
    setOTPModalVisibility(false);
  };

  const useQuery = () => {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
  };
  const query: any = useQuery();

  const login = (values: any) => {
    if (getIsRedirection()) {
      setPhoneNumber(values.phoneNumber);
      sendOtp({ ...values, isResetPin: false })
        .then((res) => res.data)
        .then((res) => {
          setOTPUniqueId(res);
          setOTPModalVisibility(true);
        });
    } else {
      if (isLoginWithPin) {
        logInWithPin(values)
          .then((res) => res.data)
          .then((res: UserLoginSuccessResponse) => {
            notification.success({
              message: t('Logged in successfully'),
            });

            setCredentialsLocalStorage(res);

            if (query && query.get(QueryParams.redirect)) {
              history.push(query.get(QueryParams.redirect));
            } else {
              history.replace(Routes.consent);
            }
          });
      } else {
        setPhoneNumber(values.phoneNumber);
        sendOtp({ ...values, isResetPin: false })
          .then((res) => res.data)
          .then((res) => {
            setOTPModalVisibility(true);
            setOTPUniqueId(res);
          });
      }
    }
  };
  const verifyLoginOtp = (values: any) => {
    userLoginOtp(values.otp);
  };
  const userLoginOtp = (otp: string) => {
    verifyOtp({
      code: otp,
      phone_number: phoneNumber,
      grant_type: 'password',
      otpUniqueID,
      isTermsAndConditionAgreed: true,
      isResetPin: false,
    })
      .then((res) => res.data)
      .then((res: UserLoginSuccessResponse) => {
        setOTPModalVisibility(false);
        notification.success({
          message: t('Logged in successfully'),
        });

        setCredentialsLocalStorage(res);

        if (query && query.get(QueryParams.redirect)) {
          history.push(query.get(QueryParams.redirect));
        } else {
          history.push(Routes.consent);
        }
      });
  };

  const isLoginwithPin = (isLoginWithpin: boolean) => {
    setIsLoginWithPin(isLoginWithpin);
  };

  const signUp = () => {
    history.push(Routes.signup);
  };

  return (
    <>
      {!getIsRedirection() && (
        <OTPInputComponent
          onCancel={closeModal}
          isOpen={isOTPModalVisible}
          onOtpSubmit={userLoginOtp}
          okText={t('CONFIRM')}
          title={t('Login')}
          // tslint:disable-next-line: jsx-no-lambda
          onResend={() => login({ phoneNumber })}
          mobileNumber={phoneNumber}
        />
      )}{' '}
      <div className='loginRoot'>
        <LoginSignupSidePanel />
        <LoginSignupForm
          phoneNumber={!!redirect && redirect.phoneNumber}
          formType={t('LOGIN')}
          formSubmit={isOTPModalVisible ? verifyLoginOtp : login}
          buttonSubSectionText={t("Don't have an account")}
          buttonSubSectionButton={t('Create Account')}
          buttonText={!!redirect ? t('Login') : t('Send OTP')}
          subButtonClick={signUp}
          isLoginWithPin={isLoginwithPin}
          isOtpInputVisible={isOTPModalVisible}
          onResendOtp={login}
        />
      </div>
    </>
  );
};

export default LoginComponent;
